import type { CSSProperties } from 'react';
import { FINDER_PATH, QR_VIEWBOX } from './qr-matrix';

/**
 * One QR rendering, everywhere: square finder eyes drawn separately from the
 * (shape-styled) data modules, quiet zone via the viewBox. Decorative in every
 * placement — callers wrap it in the aria-hidden mock it belongs to.
 */
export default function QrSvg({
  path,
  width,
  className = '',
  style,
}: {
  path: string;
  width?: number | string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg viewBox={QR_VIEWBOX} width={width} className={className} style={style} aria-hidden="true">
      <path fillRule="evenodd" fill="var(--color-ink)" d={FINDER_PATH} />
      <path fill="var(--color-ink)" d={path} />
    </svg>
  );
}
